import React from 'react';
import { GridRow, GridRowProps } from "@mui/x-data-grid-pro";
import clsx from "clsx";
import styles from './Explorer.module.scss';
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId.ts";
import { isMobile } from "react-device-detect";

export function ExplorerItemRowTrack(props: GridRowProps) {
  const [currentExplorerItemId] = useCurrentExplorerItemId();

  return (
    <div
      className={clsx({
        [styles.File]: !isMobile,
        [styles.ActiveRow]: currentExplorerItemId === props.row.id,
      })}
    >
      <GridRow
        data-type={props.row.type}
        {...props}
      />
    </div>
  );
}
